<template>
  <div class="bannerSection">
    <!-- Banner-Section-Start -->
    <section class="banner_section">
      <!-- container start -->
      <div class="container">
        <!-- row start -->
        <div class="row">
          <!-- shape animation  -->
          <span class="banner_shape1">
            <img src="/images/banner-shape1.png" alt="image" />
          </span>
          <span class="banner_shape2">
            <img src="/images/banner-shape2.png" alt="image" />
          </span>
          <span class="banner_shape3">
            <img src="/images/banner-shape3.png" alt="image" />
          </span>
          <div
            class="col-lg-6 col-md-12"
            data-aos="fade-right"
            data-aos-duration="1500"
          >
            <!-- banner text -->
            <div class="banner_text">
              <!-- h1 -->
              <h1>Best Way to Book Braiding Services — Fast, Easy & Trusted</h1>
              <!-- p -->
              <p>
                Find professional braiding experts, choose your style, pick your time, and book instantly with secure online payment.
              </p>
            </div>
            <!-- app buttons -->
            <ul class="app_btn">
              <li>
                <a href="#">
                  <img
                    class="blue_img"
                    src="/images/appstore_blue02.png"
                    alt="image"
                  />
                  <img
                    class="white_img"
                    src="/images/appstore_white.png"
                    alt="image"
                  />
                </a>
              </li>
              <li>
                <a href="#">
                  <img
                    class="blue_img"
                    src="/images/googleplay_blue02.png"
                    alt="image"
                  />
                  <img
                    class="white_img"
                    src="/images/googleplay_white.png"
                    alt="image"
                  />
                </a>
              </li>
            </ul>

            <!-- users -->
            <!-- <div class="used_app">
              <ul>
                <li><img src="/images/used01.png" alt="image" /></li>
                <li><img src="/images/used02.png" alt="image" /></li>
                <li><img src="/images/used03.png" alt="image" /></li>
                <li><img src="/images/used04.png" alt="image" /></li>
              </ul>
              <p>
                Your Perfect Braid,<br> Booked in Seconds
              </p>
            </div> -->
          </div>

          <!-- banner slides start -->
          <div
            class="col-lg-6 col-md-12"
            data-aos="fade-in"
            data-aos-duration="1500"
          >
            <div class="banner_image">
              <img
                class="moving_animation"
                src="/images/header03.png"
                alt="image"
              />
            </div>
          </div>
          <!-- banner slides end -->
        </div>
        <!-- row end -->
      </div>
      <!-- container end -->

      <!-- wave animation start -->
      <div>
        <svg
          class="waves"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 24 150 28"
          preserveAspectRatio="none"
          shape-rendering="auto"
        >
          <defs>
            <path
              id="gentle-wave"
              d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
            />
          </defs>
          <g class="parallax">
            <use
              xlink:href="#gentle-wave"
              x="48"
              y="0"
              fill="rgba(255,255,255,0.7"
            />
            <use
              xlink:href="#gentle-wave"
              x="48"
              y="3"
              fill="rgba(255,255,255,0.5)"
            />
            <use
              xlink:href="#gentle-wave"
              x="48"
              y="5"
              fill="rgba(255,255,255,0.3)"
            />
            <use xlink:href="#gentle-wave" x="48" y="7" fill="#f6f4fe" />
          </g>
        </svg>
      </div>
      <!-- wave animation end -->
    </section>
    <!-- Banner-Section-end -->
  </div>
</template>

<script>
export default {
  name: "Home",
};
</script>

